import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog' 
import { useToast } from '@/components/ui/use-toast'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { isAxiosError } from '@/api/business'
import { informOperationHub } from '@/api/business/cockpit'
import { Cockpit } from '@/queries/useCockpitQuery'
import Button from '@/components/Button' 
import {
    Form,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,

} from '@/components/ui/form' 
import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'  
import { Checkbox } from '@/components/ui/checkbox'

interface OperationHubProps {
    SK_NF: string
    isOpen: boolean 
    DD_PROCESSO_HUB: number
    onClose: () => void
}

const OperationHub = ({ isOpen, onClose, SK_NF, DD_PROCESSO_HUB }: OperationHubProps) => {
    const queryClient = useQueryClient() 
    const { toast } = useToast() 

    const schema = z.object({
        DD_PROCESSO_HUB: z.number(), 
    })

    const form = useForm<z.infer<typeof schema>>({
        resolver: zodResolver(schema),
        defaultValues: { 
            DD_PROCESSO_HUB: DD_PROCESSO_HUB || 0
        },
    })

    const { mutate, isPending: mutateLoading } = useMutation({
        mutationFn: informOperationHub,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: Cockpit.details() })
            onClose()
            form.reset() 
            toast({
                title: 'Operação Hub atualizada com sucesso',
            })
        },
        onError: (err) => {
            let errorMessage =
                'Não foi possível atualizar a operação hub. Tente novamente mais tarde.'

            if (isAxiosError(err)) {
                errorMessage = err.response?.data.message || errorMessage
            }

            toast({
                title: 'Erro ao criar a atualizar operação hub',
                description: errorMessage,
                variant: 'destructive',
            })
        },
    })

    const onSubmit = (data: z.infer<typeof schema>) => {
        console.log(data)
        mutate({
            SK_NF,
            ...data
        })
    }

    return (
        <Dialog open={isOpen} onOpenChange={onClose}  >
            <DialogContent className='bg-gray-800 border-none max-w-[400px]' aria-describedby=''>
                <DialogHeader>
                    <DialogTitle className='flex justify-between items-end'> 
                        Operação
                    </DialogTitle>
                </DialogHeader>
                <Form {...form}>
                    <form
                        onSubmit={form.handleSubmit(onSubmit)}
                        className="space-y-2 px-2 overflow-hidden overflow-y-auto"
                    >
                        <FormField
                            control={form.control}
                            name="DD_PROCESSO_HUB"
                            render={({ field }) => (
                                <FormItem className="flex flex-row items-start space-x-3 space-y-0 shadow">
                                    <FormControl>
                                        <Checkbox
                                             checked={Boolean(field.value)}
                                             onCheckedChange={(checked) => field.onChange(checked ? 1 : 0)}
                                        />
                                    </FormControl>
                                    <div className="space-y-1 leading-none">
                                        <FormLabel>
                                            Finalizar operação no Hub.
                                        </FormLabel> 
                                        <FormMessage />
                                    </div>
                                </FormItem>
                            )}
                        />
                        <DialogFooter>
                            <Button
                                type="button"
                                onClick={onClose}
                                variant="ghost"
                            >
                                Cancelar
                            </Button>
                            <Button type="submit" isLoading={mutateLoading}>
                                Confirmar
                            </Button>
                        </DialogFooter>
                    </form>
                </Form>
                <DialogFooter> 
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

export default OperationHub
